<script>
export default {
  name: 'AppFooter',
  props: {
    layoutMode: {
      type: String,
      default: 'light',
    },
  },
  computed: {
    isRTL() {
      return this.$appState.RTL
    },
  },
}
</script>

<style scoped></style>
